export const fetchHistory = async (token, setHistoryData, setLoading, setError) => {
    try {
      const response = await fetch("https://test.creative-its.com/back/api/history/show", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setHistoryData(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching history:", error);
      setError(error.message);
      setLoading(false);
    }
};
export const deleteHistoryAction = async (id, token) => {
   
    try {
      const response = await fetch(`https://test.creative-its.com/back/api/history/delete/${id}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
         
        }
      });
  
      if (!response.ok) {
        throw new Error('Failed to delete history action');
      }
  
      return await response.json();
    } catch (error) {
      console.error('Error deleting history action:', error);
      throw error; // Propagate the error to the caller
    }
  };
  